<footer>
  <section class="top-container">
    <section class="top-left-container">
      <dskhome-footer-card></dskhome-footer-card>
      <dskhome-footer-icons class="top-icons"></dskhome-footer-icons>
      <dskhome-footer-address class="address"></dskhome-footer-address>
    </section>
    <section class="top-right-container">
      <dskhome-footer-links></dskhome-footer-links>
      <button
        matButton="outlined"
        class="otp-button"
        i18n
        data-testid="footer-scroll-to-top-button"
        (click)="scrollToTop()"
      >
        До началото на страницата
        <mat-icon svgIcon="otp-sort-column-up"></mat-icon>
      </button>
      <dskhome-footer-icons class="bottom-icons start"></dskhome-footer-icons>
    </section>
  </section>
  <dskhome-footer-logo></dskhome-footer-logo>
</footer>
